import { useEffect } from 'react';

import { URL_ROUTES } from '@/constants';

const handlePopState = () => {
  const locationOrigin = window.location.origin;
  const homeParis = `${locationOrigin}${URL_ROUTES.HOME}`;

  if (homeParis === 'https://www.paris.cl/') {
    window.location.href = homeParis;
  } else {
    window.location.href = URL_ROUTES.PARIS_HOME_URL;
  }
};

const usePreventNavigation = () => {
  useEffect(() => {
    window.history.pushState(null, '', window.location.href);
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
};

export default usePreventNavigation;
